/*
 * @Description 组件  VideoPlay 视频播放
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<div class="view-tree-table">
		<!-- 组件 视频列表 -->
		<videoPlayList 
			:showBoxFlag="showTreeBoxFlag" 
			@toggleBox="toggleTreeBox" 
			:dataKeys="dataKeys"
			:videoInfos="videoInfos"
			@handleItemsRow="handleItemsRow"
			@searchVideo="searchVideo"
			/>
		<!-- 组件  播放视频 宫格 -->
		<VideoPlayGrids 
			:showBoxFlag="showTreeBoxFlag"
			:gridFilters="gridFilters"
			:pagination="pagination"
			:checkedIndexs="checkedIndexs"
			:dataList="dataList"
			@changeGrid="changeGrid"
			@toggleItem="toggleItem"
			@changePage="changePage"
			/>
	</div>
</template>

/* JS */
<script>
	// API 视频接口
	import ApiVideo from '@/request/api-video';
	// 视频接口
	import ApiCommon from '@/request/api-common';
	
	// 组件 视频列表
	import videoPlayList from './videoPlayList';
	// 组件  播放视频 宫格
	import VideoPlayGrids from './VideoPlayGrids';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
		name: "VideoPlay",
		
		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date
		 */
		components: {
			// 组件 视频列表
			videoPlayList,
			// 组件  播放视频 宫格
			VideoPlayGrids,
		},// components
		
		/**
		 * @Des 属性值
		 * @Auth
		 * @Date
		 */
		props: {
			
		},// props
		
		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date
		 */
		data() {
			return {
				// mini max tree box
				showTreeBoxFlag: true,
				
				/**
				 * @Des 宫格属性
				 * @Auth
				 * @Date
				 */
				gridFilters: {
					// 宫格
					grid: 1,
					rowNum: 1,
					colNum: 1,
				},// gridFilters
				/**
				 * @Des 分页组件
				 * @Auth
				 * @Date
				 */
				pagination: {
					total: 0,
					startNum: 0,
					limit: 1,
					currentPage: 1,
					wholePage: 1
				},
				
				/**
				 * @Des 查询条件属性
				 * @Auth
				 * @Date
				 */
				filters: {
					readMode: '',
					brand: '',
					keywords: '',
					orderBy: {
						"disk_ip": "asc",
						"disk_channel_no": "asc",
						"camera_ip": "asc",
						"number": "asc"
					},
					sortOrders: ["ascending", "descending"],
					sortable: 'custom',
					mapId: '',
					readModes: [{
						id: 1,
						name: '硬盘录像机'
					},{
						id: 2,
						name: '摄像头'
					}],
					brands: [{
						id: 1,
						name: '海康'
					},{
						id: 2,
						name: '宇视'
					},{
						id: 3,
						name: '大华'
					}],
					subtypes: [{
						id: 1,
						name: '主码流'
					},{
						id: 2,
						name: '子码流'
					}],
					codecs: [{
						id: 1,
						name: 'H.264'
					},{
						id: 2,
						name: 'H.265'
					}],
				},// filters
				
				// 选中 下标
				checkedIndexs: [],
				// 展示数据
				dataList: [],
				// 记录数据key
				dataKeys: [],
				// 自动替换 index
				autoSpliceIndex: 0,
				// 空值 下标
				nullIndexs: [],
				
				// 视频 list
				videoInfos: [],
				// 视频 list ping
				videoInfos_ping: [],
				// 交互锁
				locked: false,
				
			}// return
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 查询视频
			this.searchVideo();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			// 清除计时器
			this.clearTimers();
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			// 切换 tree box 状态
			toggleTreeBox(val) {
				this.showTreeBoxFlag = val;
			},// toggleTreeBox
			
			/**
			 * @Des 清除计时器
			 * @Auth
			 * @Date
			 */
			clearTimers() {
				// 清空定时器 检验ping数量
				if (!this.$checkEmpty(this.timer_init_data)) {
					clearInterval(this.timer_init_data);
					this.timer_init_data = null;
				}
			},// clearTimers
			
			/**
			 * @Des 点击 单元格
			 * @Auth
			 * @Date
			 */
			toggleItem(index) {
				// 空值 中止
				if (this.$checkEmpty(index)) return false;
				
				// 1宫格 中止
				if (this.gridFilters.rowNum * this.gridFilters.colNum <= 1) return false;
				
				// 有标题
				if (this.checkRowItem(index, this.dataList)) {
					// 非点击 span
					if (event.target.tagName.toLowerCase() != 'span') return false; 
				}
				
				// 选中下标
				let _index = this.checkedIndexs.indexOf(index);
				// 选中 下标
				if (_index == -1) {
					this.checkedIndexs = [index];
					
					//this.checkedIndexs.push(index);
					// 排序
					//this.checkedIndexs.sort((a, b) => {return a - b;});
				} else {
					this.checkedIndexs.splice(_index, 1);
					
					// 自动替换 index
					this.autoSpliceIndex = 0;
				}
				
			},// toggleItem
			
			/**
			 * @Des 检索宫格参数
			 * @Auth
			 * @Date
			 */
			initGridFilters() {
				return false;
				
				// 空值
				if (this.$checkEmpty(this.videoInfos)) {
					// 宫格属性
					this.gridFilters.rowNum = 0;
					this.gridFilters.colNum = 0;
					return false;
				}
				
				// 1宫格
				if (this.videoInfos.length == 1) {
					// 宫格属性
					this.gridFilters.rowNum = 1;
					this.gridFilters.colNum = 1;
					return false;
				}
				
				// 4宫格
				if (this.videoInfos.length <= 4) {
					// 宫格属性
					this.gridFilters.rowNum = 2;
					this.gridFilters.colNum = 2;
					return false;
				}
				
				// 9+宫格
				if (this.videoInfos.length > 4) {
					let nums = this.videoInfos.length;
					// 宫格属性
					this.gridFilters.rowNum = Math.ceil(nums / 3);
					if (this.gridFilters.rowNum < 3) this.gridFilters.rowNum = 3;
					this.gridFilters.colNum = 3;
					return false;
				}
				
			},// initGridFilters
			
			/**
			 * @Des 点击 宫格 按钮
			 * @Auth
			 * @Date
			 */
			changeGrid(val) {
				// 相同 中止
				if (this.gridFilters.grid == val) return false;
				
				// 分页
				this.pagination.limit = val;
				this.pagination.currentPage = 1;
				this.pagination.startNum = 0;
				this.pagination.wholePage = Math.ceil(this.pagination.total / val);
				
				// 宫格属性
				this.gridFilters.grid = val;// 宫格
				
				if (val == 1) {
					// 1宫格
					
					this.gridFilters.rowNum = 1;// 行数
					this.gridFilters.colNum = 1;// 列数
				} else if (val == 4) {
					// 4宫格
					
					this.gridFilters.rowNum = 2;// 行数
					this.gridFilters.colNum = 2;// 列数
				} else if (val == 9) {
					// 9宫格
					
					this.gridFilters.rowNum = 3;// 行数
					this.gridFilters.colNum = 3;// 列数
				}
				
				// 初始化 dataList
				this.initDataList();
				// 选中 下标
				this.checkedIndexs = [];
				
			},// changeGrid
			
			/**
			 * @Des 翻页
			 * @Auth
			 * @Date
			 */
			changePage(val) {
				// 空数据 中止
				if (this.pagination.total <= 0) return false;
				
				if (val == 'pre') {
					// 上一页
					
					// 分页
					this.pagination.currentPage--;
					if (this.pagination.currentPage <= 1) this.pagination.currentPage = 1;
					
				} else if (val = 'next') {
					// 下一页
					
					// 分页
					this.pagination.currentPage++;
					if (this.pagination.currentPage >= this.pagination.wholePage) this.pagination.currentPage = this.pagination.wholePage;
					
				}
				
				// 起始下标
				this.pagination.startNum = (this.pagination.currentPage - 1) * this.pagination.limit;
				
				// 初始化 dataList
				this.initDataList();
				
			},// changePage
			
			/**
			 * @Des 点击列表 row
			 * @Auth
			 * @Date
			 */
			handleItemsRow(row, index) {
				// ping 不通 中止
				if (row.isOpen != 1 || !(row.diskIp ? row.pingDiskIp : true) || !row.pingCameraIp || !row.realAddr) return false;
				
				// 已展示
				if (this.dataKeys.indexOf(row.number) != -1) {
					let index = this.dataKeys.indexOf(row.number);
					
					let checkedIndex = this.checkedIndexs[0];
					// 选中 下标
					if (!this.$checkEmpty(checkedIndex) && checkedIndex != index) {
						// 切换 视频
						this.dataList.splice(checkedIndex, 1, Object.assign({}, row, {rtsp: row.realAddr}));
						// 切换记录key
						this.dataKeys.splice(checkedIndex, 1, row.number);
						
						// 切换 视频
						this.dataList.splice(index, 1, null);
						// 切换记录key
						this.dataKeys.splice(index, 1, null);
						
						let _nullIndex = this.nullIndexs.indexOf(checkedIndex);
						// 空值 下标
						_nullIndex != -1 && this.nullIndexs.splice(_nullIndex, 1);
						
						// 空值 下标
						this.nullIndexs.indexOf(index) == -1 && this.nullIndexs.push(index);
						// 排序
						this.nullIndexs.sort((a, b) => {return a - b;});
						
						// 选中 下标
						//this.checkedIndexs.splice(0, 1);
					}
					
					return false;
				}
				
				let checkedIndex = this.checkedIndexs[0];
				// 选中 下标
				if (!this.$checkEmpty(checkedIndex)) {
					// 选中下标 大于数据长度
					
					// 切换 视频
					this.dataList.splice(checkedIndex, 1, Object.assign({}, row, {rtsp: row.realAddr}));
					// 切换记录key
					this.dataKeys.splice(checkedIndex, 1, row.number);
					
					let _nullIndex = this.nullIndexs.indexOf(checkedIndex);
					// 空值 下标
					_nullIndex != -1 && this.nullIndexs.splice(_nullIndex, 1);
					
					// 选中 下标
					//this.checkedIndexs.splice(0, 1);
					return false;
				}
				
				let nullIndex = this.nullIndexs[0];
				// 空值 下标
				if (!this.$checkEmpty(nullIndex)) {
					// 切换 视频
					this.dataList.splice(nullIndex, 1, Object.assign({}, row, {rtsp: row.realAddr}));
					// 切换记录key
					this.dataKeys.splice(nullIndex, 1, row.number);
					
					// 空值 下标
					this.nullIndexs.splice(0, 1);
					
					// 无空值 重新开始
					if (this.$checkEmpty(this.nullIndexs)) {
						// 自动替换 index
						this.autoSpliceIndex = 0;
					}
					return false;
				}
				
				// 切换 视频
				this.dataList.splice(this.autoSpliceIndex, 1, Object.assign({}, row, {rtsp: row.realAddr}));
				// 切换记录key
				this.dataKeys.splice(this.autoSpliceIndex, 1, row.number);
				
				// 自动替换 index
				this.autoSpliceIndex++;
				if (this.autoSpliceIndex >= this.gridFilters.grid) {
					this.autoSpliceIndex = 0;
				}
				
			},// handleItemsRow
			
			/**
			 * @Des 检索row 数据
			 * @Auth
			 * @Date
			 */
			checkRowItem(index, rows=[]) {
				// 空值 中止
				if (this.$checkEmpty(index)) return false;
				
				return !this.$checkEmpty(rows[index]) && !this.$checkEmpty(rows[index].diskChannelName);
			},// checkRowItem
			
			/**
			 * @Des 提取row 数据
			 * @Auth
			 * @Date
			 */
			extractRowItem(index, rows=[]) {
				// 空值 中止
				if (this.$checkEmpty(index)) return '';
				// 空值 中止
				if (this.$checkEmpty(rows[index])) return '';
				
				// 名称
				let diskChannelName = !this.$checkEmpty(rows[index].diskChannelName) ? rows[index].diskChannelName : '';
				// 编号
				let _number = !this.$checkEmpty(rows[index].number) ? rows[index].number : '';
				return [diskChannelName, (!this.$checkEmpty(_number) ? ('（'+ _number +'）') : '')].join('');
			},// extractRowItem
			/**
			 * @Des 提取row 数据 title
			 * @Auth
			 * @Date
			 */
			extractRowItemTitle(index, rows=[]) {
				// 空值 中止
				if (this.$checkEmpty(index)) return '';
				let row = Object.assign({}, rows[index]);
				// 空值 中止
				if (this.$checkEmpty(row)) return '';
				
				let list = [];
				
				// 视频名称
				list.push(['视频名称', (row.diskChannelName ? row.diskChannelName : '----')].join('：'));
				
				// 视频编号
				list.push(['视频编号', (row.number ? row.number : '----')].join('：'));
				
				// IP
				list.push(['IP', (row.diskIp ? row.diskIp : '----')].join('：'));
				
				// 码流类型
				let subtypeName = this.matchRowsByKey(this.filters.subtypes, 'id', row.subtype).name;
				list.push(['码流类型', (!this.$checkEmpty(subtypeName) ? subtypeName : '----')].join('：'));
				
				// 编码格式
				let codecName = this.matchRowsByKey(this.filters.codecs, 'id', row.codec).name;
				list.push(['编码格式', (!this.$checkEmpty(codecName) ? codecName : '----')].join('：'));
				
				// 读取类型
				let readModeName = this.matchRowsByKey(this.filters.readModes, 'id', row.readMode).name;
				list.push(['读取类型', (!this.$checkEmpty(readModeName) ? readModeName : '----')].join('：'));
				
				// 通道号
				list.push(['通道号', (row.diskChannelNo ? row.diskChannelNo : '----')].join('：'));
				
				// 账号
				list.push(['账号', (row.diskAccount ? row.diskAccount : '----')].join('：'));
				
				// 是否启用
				list.push(['是否启用', (row.isOpen == 1 ? '已启用' : '未启用')].join('：'));
				
				// 摄像头厂家
				let brandName = this.matchRowsByKey(this.filters.brands, 'id', row.brand).name;
				list.push(['摄像头厂家', (!this.$checkEmpty(brandName) ? brandName : '----')].join('：'));
				
				return Object.assign([], list).join('\n');
			},// extractRowItemTitle
			
			/**
			 * @Des 数据匹配
			 * @Auth
			 * @Date
			 */
			matchRowsByKey(rows, key, val){
				let obj = {};
				let keys = Object.keys(rows);
				keys.forEach((_key, index) => {
					let row = Object.assign({}, rows[_key]);
					if (row[key] == val) {
						obj = Object.assign({}, row);
					}
				});
				return obj;
			},// matchRowsByKey
			
			/**
			 * @Des 查询视频
			 * @Auth
			 * @Date
			 */
			searchVideo() {
				if(this.locked) return false;
				this.locked = true;
				
				this.$request.postJsonRequest(ApiVideo.searchVideoApi, {
					mapId: this.filters.mapId,
					readMode: this.filters.readMode,
					brand: this.filters.brand,
					keywords: this.filters.keywords,
					orderBy: this.filters.orderBy,
					projectId: this.$store.state.currentProjectId,
					offset: 0,
					limit: 0,
					total: 0
				}).then(result => {
					// result.rows = [].concat(result.rows).concat(result.rows).concat(result.rows);
					this.videoInfos = !this.$checkEmpty(result.rows) ? Object.assign([], result.rows) : [];
					// 检索宫格参数
					//this.initGridFilters();
					
					// 检测ip是否通
					this.checkIpConnect();
					
					this.locked = false;
				}).catch(error => {
					this.locked = false;
					console.error('查询摄像头异常', ApiVideo.searchVideoApi, error);
				})
            },// searchVideo
            
            /**
			 * @Des 检测ip是否通 （硬盘录像机IP）
			 * @Auth
			 * @Date 
			 */
			checkIpConnect(){
				// 请求计数
				let queryNum_disk = 0;
				let queryNum_camera = 0;
				if(this.videoInfos.length > 0){
					this.videoInfos.forEach((row, index) => {
						if(row.isOpen == 1) {
							
							if (row.diskIp) {
								this.$request.postJsonRequest(ApiCommon.checkIpConnect, {
									ip: row.diskIp,
									timeout: 1500
								}).then(result => {
									if(result.code == 0){
										row.pingDiskIp = true;
									}else{
										row.pingDiskIp = false;
									}
									queryNum_disk++;// 请求计数
								}).catch(error => {
									row.pingDiskIp = false;
									queryNum_disk++;// 请求计数
									console.log('检索IP通道异常', ApiCommon.checkIpConnect, error);
								});
							} else {
								row.pingDiskIp = false;
								queryNum_disk++;
							}
							
							if (row.cameraIp) {
								this.$request.postJsonRequest(ApiCommon.checkIpConnect, {
									ip: row.cameraIp,
									timeout: 1500
								}).then(result => {
									if(result.code == 0){
										row.pingCameraIp = true;
									}else{
										row.pingCameraIp = false;
									}
									queryNum_camera++;// 请求计数
								}).catch(error => {
									row.pingCameraIp = false;
									queryNum_camera++;// 请求计数
									console.log('检索IP通道异常', ApiCommon.checkIpConnect, error);
								})
							} else {
								row.pingCameraIp = false;
								queryNum_camera++;
							}
							
						} else {
							// 请求计数
							queryNum_disk++;
							queryNum_camera++;
						}
					})
				};
				
				// 清空定时器 检验ping数量
				if (!this.$checkEmpty(this.timer_init_data)) {
					clearInterval(this.timer_init_data);
					this.timer_init_data = null;
				}
				// 定时器轮询 检验ping数量
				this.timer_init_data = setInterval(() => {
					if (queryNum_disk < this.videoInfos.length || queryNum_camera < this.videoInfos.length) {
						// 未请求完毕
						return false;
					}
					// 清空定时器 检验ping数量
					clearInterval(this.timer_init_data);
					this.timer_init_data = null;
					
					// 视频 list ping
					let videoInfos_ping = [];
					Object.assign([], this.videoInfos).forEach((row, index) => {
						// ping 通
						if (row.isOpen == 1 && row.realAddr && (row.diskIp ? row.pingDiskIp : true) && row.pingCameraIp) {
							videoInfos_ping.push(row);
						}
					});
					// 视频 list ping
					this.videoInfos_ping = Object.assign([], videoInfos_ping);
					
					// 分页
					this.pagination.total = this.videoInfos_ping.length;
					this.pagination.limit = this.gridFilters.grid;
					this.pagination.currentPage = 1;
					this.pagination.startNum = 0;
					this.pagination.wholePage = Math.ceil(this.pagination.total / this.pagination.limit);
					
					// 初始化 dataList
					this.initDataList();
				}, 200);
				
			},// checkIpConnect
			
            /**
			 * @Des 初始化 dataList
			 * @Auth
			 * @Date
			 */
			initDataList() {
				/*
				let dataList = [];
				// 遍历
				Object.assign([], this.videoInfos).forEach((row, index) => {
					if (dataList.length < this.gridFilters.grid) {
						dataList.push(row);
					}
				});
				*/
				
				let dataList = Object.assign([], this.videoInfos_ping).splice(this.pagination.startNum, this.pagination.limit);
				// null 占位
				for (let i = dataList.length; i < this.gridFilters.grid; i++) {
					dataList.push(null);
				}
				
				let dataKeys = [];
				let nullIndexs = [];
				Object.assign([], dataList).forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row) || this.$checkEmpty(row.number)) {
						 dataKeys.push(null);
						 // 空值 下标
						 nullIndexs.indexOf(index) == -1 && nullIndexs.push(index);
						 return true;
					}
					row.rtsp = row.realAddr;
					dataKeys.push(row.number);
				});
				
				// 展示数据
				this.dataList = Object.assign([], dataList);
				// 记录数据key
				this.dataKeys = Object.assign([], dataKeys);
				
				// 排序
				nullIndexs.sort((a, b) => {return a - b;});
				// 空值 下标
				this.nullIndexs = Object.assign([], nullIndexs);
				
				// 自动替换 index
				this.autoSpliceIndex = 0;
				
			},// initDataList
            
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style src="@/static_dazzle/css/grid/grid-contain-view.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Video/VideoPlay.vue